import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

const LeftArrow = () => {
  const paths = [
    <path
      d="M10.243 5.74029C10.9778 5.12764 11.5304 4.10123 12.2652 3.28242C13 2.46361 14.1008 1.85387 15.0188 1.24268C15.5695 0.834735 15.2059 -0.198955 14.6551 0.208992C12.8213 1.01907 9.51987 2.43598 9.32923 4.90839C9.14396 5.73156 9.69231 6.14824 10.243 5.74029Z"
      fill="black"
    />,
    <path
      d="M1.95427 21.5488C2.69026 20.3177 2.87762 18.8761 3.24815 17.4359C3.80246 15.791 4.35677 14.1461 5.27624 12.9164C5.46032 12.5056 5.09515 12.0904 4.7285 12.2936C2.70757 14.3392 0.49928 17.8264 0.306553 21.1234C0.487644 21.9495 1.58582 22.1644 1.95427 21.5488Z"
      fill="black"
    />,
    <path
      d="M9.42749 34.3898C8.51428 33.3517 7.4179 32.5184 6.68877 31.2756C5.95933 30.0329 5.77974 28.7945 5.60103 27.3499C5.41994 26.5239 4.68603 26.9303 4.50076 27.5474C4.12456 31.0491 5.58074 34.3592 8.32424 35.8241C9.23924 36.0376 10.1581 35.0141 9.42749 34.3898Z"
      fill="black"
    />,
    <path
      d="M20.5925 37.5712C20.776 37.3665 20.7772 36.9542 20.5955 36.5404C19.8649 35.71 18.9487 35.9088 18.2157 35.903C16.9337 35.8928 15.8353 35.678 14.738 35.0508C14.0056 34.8388 13.6365 35.8667 14.1849 36.2833C15.2822 36.9105 16.38 37.3316 17.4785 37.5465C18.3926 38.1722 19.8565 38.5961 20.5925 37.5712Z"
      fill="black"
    />,
    <path
      d="M25.5505 33.2812C26.1036 32.0486 27.0225 31.0251 27.7582 30.0001C28.6774 28.9766 29.5957 28.1593 30.3317 26.9282C30.7007 26.1065 29.9698 25.276 29.2362 25.6825C28.1347 26.4984 27.2152 27.7281 26.2955 28.9577C25.5601 29.9827 24.8238 31.2138 24.271 32.4464C23.9016 33.4739 24.998 34.3076 25.5505 33.2812Z"
      fill="black"
    />,
    <path
      d="M31.4535 19.103C31.4577 17.6599 31.2784 16.4215 30.7325 15.1802C30.1859 14.1451 29.091 12.6933 27.9914 12.6845C27.4418 12.6802 26.8899 13.5004 27.2548 14.1218C27.8019 14.9508 28.5331 15.5751 29.0809 16.1979C29.628 17.0269 29.9911 18.0606 29.9887 18.8852C29.9851 20.1221 31.2671 20.3381 31.4535 19.103Z"
      fill="black"
    />,
    <path
      d="M18.2647 18.9982C19.3661 18.1823 20.8316 18.194 21.9295 18.615C22.4784 18.8255 22.848 17.7977 22.2991 17.5871C20.8355 16.957 19.5544 16.5346 18.0878 16.9352C16.8046 17.3374 14.9696 18.3536 14.5987 19.7938C14.4141 20.4108 14.9618 21.0336 15.5119 20.8318C16.6113 20.6344 17.3473 19.6094 18.2647 18.9982Z"
      fill="black"
    />,
    <path
      d="M11.4462 33.1692C11.8147 32.3474 11.6345 31.3152 12.0041 30.2873C12.3738 29.0533 13.1098 28.0284 13.8452 27.0034C14.3965 26.3893 13.6665 25.5588 13.1151 26.173C11.6455 27.6044 9.07177 30.6764 9.79702 33.1561C10.1613 33.9833 11.2604 33.992 11.4462 33.1692Z"
      fill="black"
    />,
    <path
      d="M15.2368 52.578C13.7791 49.8864 12.3212 47.1947 11.4139 44.3013C11.0497 43.4737 9.9503 43.6712 10.1302 44.7034C10.8537 48.0077 11.3925 51.7229 14.1342 53.8062C14.6819 54.4294 15.6005 53.4059 15.2368 52.578Z"
      fill="black"
    />,
    <path
      d="M26.9375 60.5054C27.6705 60.305 27.6735 59.2743 27.3083 58.859C26.5789 57.8224 24.9315 57.397 23.8348 56.5637C22.7381 55.7303 21.642 54.6908 20.5459 53.6513C19.9982 53.0285 19.0793 54.052 19.6268 54.6748C20.7216 56.1267 21.8171 57.3723 22.9126 58.618C24.0087 59.6575 25.4706 60.9057 26.9375 60.5054Z"
      fill="black"
    />,
    <path
      d="M42.1358 62.4815C42.6866 62.0736 42.5073 60.8352 41.774 61.0355C38.8422 61.2184 36.0909 62.4335 33.3436 62.4117C32.794 62.4073 32.7916 63.232 33.3412 63.2363C36.2711 63.4658 39.5663 64.3162 42.1358 62.4815Z"
      fill="black"
    />,
    <path
      d="M48.7399 59.2354C49.8408 58.6257 50.9416 58.0159 51.8605 56.9924C52.9623 55.9704 54.4307 54.9512 54.8012 53.511C54.9862 52.894 54.439 52.065 53.8883 52.473C52.788 52.8766 52.0517 54.1077 51.3169 54.9265C50.3978 55.95 49.2954 57.1782 48.194 57.9941C47.4592 58.6068 48.0057 59.6419 48.7399 59.2354Z"
      fill="black"
    />,
    <path
      d="M59.4043 45.5073C60.5069 44.2791 61.0606 42.8404 61.6149 41.1955C61.9867 39.343 62.3602 36.872 61.8154 35.2184C61.4521 34.1847 60.353 34.176 59.9836 35.2039C58.8756 38.2875 60.3309 41.8038 58.3076 44.674C57.9394 45.2892 58.8535 45.9153 59.4043 45.5073Z"
      fill="black"
    />,
    <path
      d="M55.5946 32.6948C53.4048 29.7912 48.4733 24.8041 44.9831 28.075C44.4318 28.6891 44.7954 29.7228 45.3444 29.9333C46.8086 30.3573 48.2755 29.9566 49.5563 30.3791C51.3866 31.0121 53.0307 32.4683 54.4926 33.7168C55.4064 34.3426 56.1421 33.318 55.5946 32.6948Z"
      fill="black"
    />,
    <path
      d="M36.7113 37.905C37.6311 36.6753 38.3671 35.4442 39.2865 34.2145C40.3892 32.9863 41.6735 32.1719 42.9585 31.3575C43.5086 31.1557 43.1449 30.122 42.5948 30.3238C39.6618 31.1251 35.2593 33.1518 35.4308 37.2763C35.4293 37.8948 36.3431 38.5205 36.7113 37.905Z"
      fill="black"
    />,
    <path
      d="M32.0931 51.2691C32.6498 48.7996 32.2915 46.1167 33.7632 44.0667C34.1304 43.6573 33.5827 43.0345 33.2148 43.4439C31.1945 45.4895 30.4522 48.576 30.9934 51.4665C30.9922 51.8788 31.9081 51.8861 32.0931 51.2691Z"
      fill="black"
    />,
    <path
      d="M29.2922 69.5952C30.7654 66.9268 30.4116 62.5943 30.0544 59.4994C30.0568 58.6747 28.9578 58.666 28.7719 59.4892C28.5842 61.137 28.5789 62.9924 28.2074 64.6387C28.0204 66.0803 27.4667 67.5191 27.4625 68.9622C27.6418 70.2005 28.9237 70.4165 29.2922 69.5952Z"
      fill="black"
    />,
    <path
      d="M36.0228 85.9353C35.4781 84.2817 34.5651 83.2436 33.6537 81.7933C32.5582 80.3414 31.83 78.8929 31.1024 77.2375C30.7381 76.4099 29.4543 77.0182 29.6351 77.8443C29.997 79.4965 30.7259 80.7392 31.4541 82.1881C32.3655 83.8446 33.2766 85.5015 34.5544 86.9544C35.1022 87.5769 36.3865 86.9686 36.0228 85.9353Z"
      fill="black"
    />,
    <path
      d="M49.5529 94.7014C50.2865 94.5011 50.2901 93.2642 49.5577 93.0522C47.5451 92.4177 45.7145 91.7847 44.0704 90.3285C43.5221 89.9119 42.9707 90.526 43.3356 91.1473C44.9779 93.222 46.804 95.0916 49.5529 94.7014Z"
      fill="black"
    />,
    <path
      d="M64.9405 94.6172C65.675 94.0045 65.1291 92.7632 64.3958 92.9635C62.0121 93.7689 59.447 93.9551 57.065 94.1423C56.3323 94.1365 56.3282 95.5796 57.0609 95.5854C59.6242 96.0184 62.5538 96.4536 64.9405 94.6172Z"
      fill="black"
    />,
    <path
      d="M80.1628 88.3474C80.8973 87.7347 79.9844 86.6967 79.2505 87.1032C76.6824 88.3198 74.2957 90.1562 71.727 91.579C71.1769 91.7808 71.5403 92.8144 72.0904 92.6127C75.0237 91.8113 77.9581 90.5973 80.1628 88.3474Z"
      fill="black"
    />,
    <path
      d="M84.7704 78.6941C86.4244 76.8518 88.8159 73.3664 87.9083 70.4729C87.7275 69.6469 86.6285 69.6381 86.4429 70.4613C86.073 71.6953 86.2526 72.9337 85.8826 74.1677C85.5127 75.4018 84.7764 76.6329 83.8575 77.6564C83.4894 78.2719 84.22 79.1024 84.7704 78.6941Z"
      fill="black"
    />,
    <path
      d="M85.7284 64.2708C85.7337 62.4154 85.3721 60.7632 84.0935 59.5161C82.9974 58.4766 80.6208 56.8085 79.1524 57.8276C78.4185 58.2341 78.5987 59.2663 79.1465 59.8892C79.6948 60.3058 80.0612 60.3087 80.6107 60.3131C81.1602 60.3175 81.8923 60.5294 82.4407 60.9461C83.538 61.5733 84.8166 62.8204 84.9956 64.265C84.9936 64.8831 85.7266 64.8889 85.7284 64.2708Z"
      fill="black"
    />,
    <path
      d="M66.8487 68.2441C68.134 67.2235 69.0546 65.5815 70.1567 64.5591C71.4425 63.3327 72.9103 62.5197 74.3781 61.7067C75.1121 61.3003 74.5661 60.059 73.8328 60.2593C70.8995 61.0606 66.4961 63.4996 65.5701 66.997C65.3845 67.8201 66.298 68.6517 66.8487 68.2441Z"
      fill="black"
    />,
    <path
      d="M58.5574 84.8772C59.2949 83.2338 59.4828 81.586 60.0377 79.735C60.5944 77.2652 61.6995 75.2123 63.1703 73.3686C63.9054 72.5501 62.8099 71.3041 62.0748 72.1229C59.3187 74.9873 56.9225 80.1222 56.91 84.4515C56.9079 85.2761 58.1886 85.699 58.5574 84.8772Z"
      fill="black"
    />,
    <path
      d="M70.7814 101.879C69.8685 100.841 68.5868 100.625 67.4889 100.204C66.0253 99.5736 64.3791 98.7359 63.0998 97.6946C62.3695 96.8645 61.2668 98.0927 61.9971 98.9231C63.0926 100.169 64.3719 101.209 65.6518 102.045C66.9316 102.88 68.5773 103.923 70.0433 103.729C70.7766 103.529 71.3291 102.502 70.7814 101.879Z"
      fill="black"
    />,
    <path
      d="M83.9547 107.344C81.9475 104.648 77.7368 103.79 74.8053 103.973C73.8894 103.966 73.8852 105.409 74.8005 105.622C76.0822 105.838 77.5464 106.263 78.8275 106.685C80.2911 107.315 81.5698 108.562 83.034 108.986C83.9499 108.994 84.5027 107.967 83.9547 107.344Z"
      fill="black"
    />,
    <path
      d="M93.6393 115.668C93.826 114.432 92.9131 113.394 92.366 112.565C91.6362 111.528 90.539 110.901 89.6243 110.481C88.7096 110.062 87.9727 111.499 88.8874 111.919C89.6183 112.543 90.3498 112.961 91.0801 113.791C91.6273 114.62 91.8069 115.859 92.7216 116.279C92.9042 116.486 93.4543 116.285 93.6393 115.668Z"
      fill="black"
    />,
    <path
      d="M97.8189 127.246C99.6519 126.848 101.669 126.246 103.503 125.436C104.053 125.234 104.604 124.62 104.606 124.001C104.435 119.877 103.347 116.157 101.342 112.636C100.613 111.394 98.961 112.412 99.5063 113.859C100.963 116.757 101.688 119.649 101.679 122.741C100.395 123.143 99.1119 123.545 97.8285 123.947C96.3618 124.348 94.897 124.13 93.795 125.152C93.0605 125.765 93.4238 126.799 93.9722 127.215C95.0683 128.255 96.719 127.649 97.8189 127.246Z"
      fill="black"
    />,
  ];
  const controls = useAnimation();

  useEffect(() => {
    controls.start("animate");
  }, [controls]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105"
      height="128"
      viewBox="0 0 105 128"
      fill="none"
    >
      {paths.map((path, index) => (
        <motion.path
          key={index}
          d={path.props.d}
          fill="black"
          initial={{ pathLength: 0, fill: "rgba(0, 0, 0, 0)" }}
          animate={{ pathLength: 1, fill: "#000000" }}
          transition={{
            pathLength: {
              delay: index * 0.09,
              type: "tween",
              duration: 0.3,
              bounce: 0,
            },
            fill: { delay: index * 0.09, type: "tween", duration: 0.1 },
          }}
        />
      ))}
    </svg>
  );
};

export default LeftArrow;
